/* eslint-disable react/display-name */
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { useTranslation } from 'react-i18next';

import { ListItem, ListItemIcon, ListItemText, Collapse } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import SideBarListItem from './SideBarListItem';

const useStyles = makeStyles((theme) => ({
  icon: {
    color: theme.palette.icon,
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(1),
  },
  expandIcon: {
    marginLeft: 'auto',
    height: 20,
    width: 20,
  },
}));

const SideBarList = (props) => {
  const { title, href, depth, children, icon: Icon, className, selected } = props;

  const history = useHistory();
  const classes = useStyles();
  const { t } = useTranslation();

  const [open, setOpen] = useState(selected);

  const onClick = () => {
    history.push(href);
  };

  const handleToggle = () => {
    setOpen(!open);
  };
  let paddingLeft = 16;

  if (depth > 0) {
    paddingLeft = 32 + 16 * depth;
  }

  const style = {
    paddingLeft,
  };

  if (children) {
    return (
      <>
        <ListItem style={style} button onClick={handleToggle} className={className} disableGutters>
          {Icon && (
            <ListItemIcon>
              <Icon className={classes.icon} />
            </ListItemIcon>
          )}
          <ListItemText primary={t(title)} />
          {open ? (
            <ExpandLessIcon className={clsx(classes.expandIcon, classes.icon)} />
          ) : (
            <ExpandMoreIcon className={clsx(classes.expandIcon, classes.icon)} />
          )}
        </ListItem>
        <Collapse in={open}>{children}</Collapse>
      </>
    );
  }
  return <SideBarListItem style={style} selected={selected} onClick={onClick} className={className} {...props} />;
};

SideBarList.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  depth: PropTypes.number,
  href: PropTypes.string,
  icon: PropTypes.any,
  selected: PropTypes.bool,
  title: PropTypes.string.isRequired,
};

SideBarList.defaultProps = {
  depth: 0,
  selected: false,
  children: undefined,
  className: undefined,
  href: undefined,
  icon: undefined,
};

export default SideBarList;
